import { Component, ChangeDetectionStrategy, input } from '@angular/core'
import { MetricDetailSubHeader } from '@features/metric-detail/models/metric-detail.models'
import { PLAYER_DEMARCATION_FALLBACK_KEY, PLAYER_DEMARCATION_KEYS } from '@core/constants/player.constants'
import { DefaultImageModule } from '@mediacoach/ui'
import { NgClass } from '@angular/common'
import { DemarcationPipe } from '@shared/pipes/demarcation.pipe'

@Component({
  selector: 'mcm-metric-detail-sub-header',
  templateUrl: './metric-detail-sub-header.component.html',
  styleUrls: ['./metric-detail-sub-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DefaultImageModule, NgClass, DemarcationPipe]
})
export class MetricDetailSubHeaderComponent {
  readonly subHeader = input.required<MetricDetailSubHeader>()
  readonly playerDemarcationKeys = PLAYER_DEMARCATION_KEYS
  readonly playerDemarcationFallbackKey = PLAYER_DEMARCATION_FALLBACK_KEY
}
